import { Component, Inject } from '@angular/core';
import Env from '@ridango/core/env';
import { ApplicationFacade } from '@ridango/components';
import { Router } from '@angular/router';

@Component({
    templateUrl: './terms-page.component.html',
    styleUrls: ['./terms-page.component.scss']
})
export class TermsPageComponent {
    assetsPath$ = this.applicationFacade.assetsPath$;
    termsUrl$ = this.applicationFacade.termsUrl$;

    constructor(
        @Inject('ENV') public env: Env,
        private applicationFacade: ApplicationFacade,
        private router: Router
    ) {}

    handleBackClicked(): void {
        if (window.history.length > 1) {
            window.history.back();
        } else {
            this.router.navigate(['/']).then(() => {
                // do nothing
            });
        }
    }
}
